import { render, staticRenderFns } from "./MiddleBox.vue?vue&type=template&id=3da57731&scoped=true&"
import script from "./MiddleBox.vue?vue&type=script&lang=js&"
export * from "./MiddleBox.vue?vue&type=script&lang=js&"
import style0 from "./MiddleBox.vue?vue&type=style&index=0&id=3da57731&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da57731",
  null
  
)

export default component.exports